const SLUG_CHARS_PATTERN = /[^a-z0-9-]/g;

export const CHARITY_ID_MAX_LENGTH = 40;
export const DOMAIN_MAX_LENGTH = 63;

export function sanitizeDomainInput(value: string): string {
  return stripDomainSuffix(value)
    .toLowerCase()
    .replace(SLUG_CHARS_PATTERN, "")
    .slice(0, DOMAIN_MAX_LENGTH);
}

export function sanitizeCharityIdInput(value: string): string {
  return value
    .toLowerCase()
    .replace(SLUG_CHARS_PATTERN, "")
    .slice(0, CHARITY_ID_MAX_LENGTH);
}

export function suggestSubdomainFromName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) {
    return "";
  }
  let segment = trimmed;
  const separator = " - ";
  const separatorIndex = trimmed.indexOf(separator);
  if (separatorIndex >= 0) {
    segment = trimmed.substring(separatorIndex + separator.length);
  }
  return segment.replace(/[\s-]+/g, "").toLowerCase();
}

export function stripDomainSuffix(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/\.(alpha\.)?viewspark\.org.*$/, "");
}

export function domainSuffixForEnvironment(isProduction: boolean): string {
  return isProduction ? ".viewspark.org" : ".alpha.viewspark.org";
}
